var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -1 24 24",
    width: 48,
    height: 48,
    "aria-label": "Projektowanie",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#52d552",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2 L20 6.5 V15.5 L12 20 L4 15.5 V6.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2 V12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5 L12 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5 L12 11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/cad.b059f65ccf98903a72cda4901a88efb7.svg";
export { ForwardRef as ReactComponent };